// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__1bx1c","icon":"style_icon__2-8Xz","title":"style_title__3mL7q","logo":"style_logo__2zcpN","logoContainer":"style_logoContainer__3LmRj"};